import React, { useMemo } from 'react';
import View from './View';
import {
  getInNetworkFamilyDeductible,
  getInNetworkFamilyOutOfPocketMax,
  getInNetworkIndividualDeductible,
  getInNetworkIndividualOutOfPocketMax,
} from '../../../../../../../Account/Profile/Insurance/util/insuranceDetails';
import { isEmpty } from '../../../../../../../../core/util/empty';

class SpendCategory {
  static INDIVIDUAL_DEDUCTIBLE = 'individual deductible';

  static FAMILY_DEDUCTIBLE = 'family deductible';

  static INDIVIDUAL_OOP = 'individual out-of-pocket maximum';

  static FAMILY_OOP = 'family out-of-pocket maximum';
}

const operations = [
  {
    category: SpendCategory.INDIVIDUAL_DEDUCTIBLE,
    func: getInNetworkIndividualDeductible,
  },
  {
    category: SpendCategory.FAMILY_DEDUCTIBLE,
    func: getInNetworkFamilyDeductible,
  },
  {
    category: SpendCategory.INDIVIDUAL_OOP,
    func: getInNetworkIndividualOutOfPocketMax,
  },
  {
    category: SpendCategory.FAMILY_OOP,
    func: getInNetworkFamilyOutOfPocketMax,
  },
];

const getValues = (insuranceDetails: any) => {
  let values: any = [];
  let details;
  operations.forEach(({ category, func }) => {
    details = func(insuranceDetails);
    !isEmpty(details) &&
      values.push({
        category,
        ...details,
      });
  });
  return values;
};

const getViewProps = (insuranceDetails: any) => {
  const values = getValues(insuranceDetails);
  values.sort((a: any, b: any) => a.limit - b.limit);
  const filtered = values.filter((o: any) => o.remaining > 0);
  const [first] = filtered;
  const [last] = values.slice(-1);

  if (isEmpty(first)) return last;
  return first;
};

type ControllerProps = {
  insuranceDetails?: any;
  insuranceCarrierName?: string;
  logo: string;
};

const Controller = (props: ControllerProps) => {
  const { insuranceCarrierName, insuranceDetails, logo } = props;
  const viewProps = useMemo(() => getViewProps(insuranceDetails), [insuranceDetails]);

  return (
    !isEmpty(viewProps) && (
      <View
        applied={parseInt(viewProps.applied, 10)}
        category={viewProps.category}
        insuranceCarrierName={insuranceCarrierName}
        limit={parseInt(viewProps.limit, 10)}
        logo={logo}
      />
    )
  );
};

export default Controller;
export { getViewProps, SpendCategory };
